import { IBaseQueryParameters } from './IBaseQueryParameters.js'

/**
 * An interface that defines the base options for all API requests. It is then
 * extended by the interfaces for each endpoints request options.
 */
export interface IBaseOptions<P = string[], Q = IBaseQueryParameters> {
  /** The parameters appended to the endpoint. */
  pathParams?: P

  /** The parameters appended to the ended of the URL as query parameters. */
  queryParams?: Q
}
